import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BasePage from '../../baseClasses/BasePage';
import Home from '../../containers/Home';
import NotificationsPopup from '../../components/NotificationsPopup';
import MobileHeader from '../../components/MobileHeader';
import dataModel from '../../models/DataModel';

import '../MobileWrapper.scss';
import './NotificationsWrapper.scss';
import mobileBridge from '../../helpers/MobileBridge';

class NotificationsWrapper extends BasePage {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    mobileBridge.initialize(this.props.history);
    if (!this.props.notifications) {
      this.notifications = this.props.notificationsDataModel.notifications;
    }
    dataModel.mobileBridge.fireNativeEvent('hybrid.notifications', { data: { has_unread: false } });
  }

  render() {
    if (this.state.navPath) {
      this.props.history.push({ pathname: this.state.navPath });
    }

    if (!this.props.notifications) {
      return (
        <Home type={'notifications'} message={'Awaiting Initialization'} />
      );
    }
    return (
      <div className='mobile-wrapper'>
        <MobileHeader
          headerTitle={this.textMap.notifications}
          noBackButton={true}
        />
        {this.props.systemPopup}
        <div className="content-wrapper" id="notifications-wrapper">
          <NotificationsPopup
            dontAnimate={true}
            handleUpdateNotification={this.handleUpdateNotification}
            isMobile={true}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dataModel: dataModel,
    notificationsDataModel: dataModel.notificationsDataModel,
    notifications: state.notifications.notifications,
    navigateUri: state.main.navigateUri,
    systemPopup: state.main.systemPopup,
  };
};
export default withRouter(connect(mapStateToProps)(NotificationsWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/NotificationsWrapper/index.js